import { IItem } from '@bimser/core';
import { Menu, MenuProps } from 'antd';
import React, { JSX, useEffect, useRef } from 'react';
import { IMenuInfo, IMenuItemClickEventArgs, IMenuProps } from './entities';
import { findItemByPath, generateMenuContent } from './helpers/generateMenuContent';

type USE_AS_PROPS_RETURNER = { getOnlyMenuProps: boolean };

export default function BCMenu<
	T extends
		| USE_AS_PROPS_RETURNER
		| React.PropsWithChildren<IMenuProps> = React.PropsWithChildren<IMenuProps>
>(props?: T): T extends USE_AS_PROPS_RETURNER ? MenuProps : JSX.Element {
	const JsxProps = props as React.PropsWithChildren<IMenuProps>;
	const {
		mode,
		defaultOpenKeys,
		defaultSelectedKeys,
		items,
		selectedKeys,
		openKeys,
		triggerMode,
		className,
		style,
		selectable,
		forceSubMenuRender
	} = JsxProps;
	const menuItemList = useRef<Array<{ domItem: HTMLElement; data?: any }>>([]);
	const renderMenuItem = generateMenuContent(JsxProps, addRefToMenuItemList);

	useEffect(() => {
		if (JsxProps.forceNativeClick) {
			menuItemList.current.forEach(elem => {
				elem.domItem.onclick = e => {
					onClick({ domEvent: e as any, key: 'onClick', keyPath: [] });
				};
			});
		}

		const subMenuElement = document.getElementsByClassName(JsxProps.popupClassName);
		for (const element of Array.from(subMenuElement)) {
			element
				.querySelector('ul')
				?.style.setProperty(
					'background-color',
					JsxProps.style?.backgroundColor,
					'important'
				);
		}
	}, []);

	function addRefToMenuItemList(domNode: HTMLDivElement, item: IItem) {
		menuItemList.current.push({ data: item, domItem: domNode });
	}

	function onClick(args: IMenuInfo) {
		if (JsxProps.onClick) {
			const data = findItemByPath(items, (args.keyPath && [...args.keyPath])?.reverse());
			JsxProps.onClick({ domEvent: args.domEvent, data });
		}
	}

	function onOpenChange(_openKeys: string[]) {
		if (JsxProps.onOpenChange) {
			JsxProps.onOpenChange(_openKeys);
		}
	}

	function getMenuProps(): MenuProps {
		return {
			onClick,
			mode: mode,
			className: className,
			selectable: selectable || false,
			defaultOpenKeys: defaultOpenKeys,
			openKeys: openKeys,
			selectedKeys: selectedKeys,
			style: style,
			defaultSelectedKeys: defaultSelectedKeys,
			triggerSubMenuAction: triggerMode || 'hover',
			onOpenChange,
			forceSubMenuRender: forceSubMenuRender,
			items: items.length ? renderMenuItem(items) : []
		};
	}

	if (props.getOnlyMenuProps) {
		return getMenuProps() as any;
	}

	return (
		<div>
			<Menu {...getMenuProps()}></Menu>
		</div>
	) as any;
}

export { IMenuItemClickEventArgs, IMenuProps, MenuProps };
